import React, { useEffect, useState } from 'react';
import '../../assets/landingPageCss/common.css';
import '../../assets/landingPageCss/style.css';
import '../../assets/landingPageCss/bookDemo.css';
import '../../assets/landingPageCss/sigma.css';
import logoTransparentPng from '../../assets/images/landing/logoTransparent.png';
import { Link } from 'react-router-dom';
import logoLight from "../../assets/images/logo-light.svg";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";

function Sigma() {
  document.title = 'Adcropper | Sigma';

  const [showContactSelect, setShowContactSelect] = useState(false);
  const [selectedCompanyType, setSelectedCompanyType] = useState('22');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  function showSelectedCompanyType() {
    if (selectedCompanyType === '6') {
      return 'Agency'
    } else if (selectedCompanyType === '7') {
      return 'Brand'
    } else if (selectedCompanyType === '8') {
      return 'Consultancy'
    } else if (selectedCompanyType === '9') {
      return 'Educational'
    } else if (selectedCompanyType === '10') {
      return 'Freelancer';
    } else if (selectedCompanyType === '22') {
      return 'Sigma Attendees';
    } else {
      return (
        <p style={{ color: '#c0ccda', margin: '0', userSelect: 'none' }}>Select Company Type</p>
      )
    }
  }

  function changeCompanyType(val) {
    setSelectedCompanyType(val);
    setShowContactSelect(false);
  }

  return (
    <ParticlesAuth>
      <div className="auth-page-content mt-lg-5 mt-xs-5 mt-sm-5">
        <div class="bookDemoForm">
          <img src={logoLight} className='mb-4' height="40" />
          <div
            className="sib-form"
            style={{ textAlign: "center", backgroundColor: "#EFF2F7" }}
          >
            <div id="sib-form-container" className="sib-form-container">
              <div
                id="sib-container"
                className="sib-container--large sib-container--vertical"
                style={{ textAlign: 'center', backgroundColor: 'rgba(255,255,255,1)', maxWidth: '540px', borderRadius: '6px', borderWidth: '1px', borderColor: '#C0CCD9', borderStyle: 'solid' }}
              >
                <form
                  id="sib-form"
                  method="POST"
                  onSubmit={(e) => console.log(e)}
                  action="https://ddcc9bef.sibforms.com/serve/MUIFABlCzWgY5f6QkO7J7YlUV2L0LR1k7FS2s5KETmfjSZAphAX-uo94EbcSSkdUjT0WsJ8j_ibsEmdBSnRkBB_1S4QhihhUN5cleLs6z04cw3F6T4Z2KXX_cxTo_Gi4BPV5jodpJ2C64FKLO7-kS9xdKKymGvIRdeqWpK57kKMJySGlz4BZfrklMqeRjBJe86SuHLfUNtThrlNJ"
                >
                  <div class="formRow" style={{ padding: "8px 0" }}>
                    <div className="sib-input sib-form-block">
                      <div className="form__entry entry_block">
                        <div className="form__label-row ">
                          <label
                            className="entry__label"
                            style={{
                              fontWeight: 700,
                              textAlign: "left",
                              fontSize: 16,
                              fontFamily: "Helvetica, sans-serif",
                              color: "#3c4858"
                            }}
                            htmlFor="FIRSTNAME"
                            data-required="*"
                          >
                            First Name
                          </label>
                          <div className="entry__field">
                            <input
                              className="input "
                              maxLength={200}
                              type="text"
                              id="FIRSTNAME"
                              name="FIRSTNAME"
                              autoComplete="off"
                              placeholder="First Name"
                              data-required="true"
                              required=""
                            />
                          </div>
                        </div>
                        <label
                          className="entry__error entry__error--primary"
                          style={{
                            fontSize: 16,
                            textAlign: "left",
                            fontFamily: "Helvetica, sans-serif",
                            color: "#661d1d",
                            backgroundColor: "#ffeded",
                            borderRadius: 3,
                            borderColor: "#ff4949"
                          }}
                        ></label>
                      </div>
                    </div>
                    <div className="sib-input sib-form-block">
                      <div className="form__entry entry_block">
                        <div className="form__label-row ">
                          <label
                            className="entry__label"
                            style={{
                              fontWeight: 700,
                              textAlign: "left",
                              fontSize: 16,
                              fontFamily: "Helvetica, sans-serif",
                              color: "#3c4858"
                            }}
                            htmlFor="LASTNAME"
                            data-required="*"
                          >
                            Last Name
                          </label>
                          <div className="entry__field">
                            <input
                              className="input "
                              maxLength={200}
                              type="text"
                              id="LASTNAME"
                              name="LASTNAME"
                              autoComplete="off"
                              placeholder="Last Name"
                              data-required="true"
                              required=""
                            />
                          </div>
                        </div>
                        <label
                          className="entry__error entry__error--primary"
                          style={{
                            fontSize: 16,
                            textAlign: "left",
                            fontFamily: "Helvetica, sans-serif",
                            color: "#661d1d",
                            backgroundColor: "#ffeded",
                            borderRadius: 3,
                            borderColor: "#ff4949"
                          }}
                        ></label>
                      </div>
                    </div>
                  </div>
                  <div class="formRow" style={{ padding: "8px 0" }}>
                    <div className="sib-input sib-form-block">
                      <div className="form__entry entry_block">
                        <div className="form__label-row ">
                          <label
                            className="entry__label"
                            style={{
                              fontWeight: 700,
                              textAlign: "left",
                              fontSize: 16,
                              fontFamily: "Helvetica, sans-serif",
                              color: "#3c4858"
                            }}
                            htmlFor="EMAIL"
                            data-required="*"
                          >
                            Company Email
                          </label>
                          <div className="entry__field">
                            <input
                              className="input "
                              type="text"
                              id="EMAIL"
                              name="EMAIL"
                              autoComplete="off"
                              placeholder="example@yourcompany.com"
                              data-required="true"
                              required=""
                            />
                          </div>
                        </div>
                        <label
                          className="entry__error entry__error--primary"
                          style={{
                            fontSize: 16,
                            textAlign: "left",
                            fontFamily: "Helvetica, sans-serif",
                            color: "#661d1d",
                            backgroundColor: "#ffeded",
                            borderRadius: 3,
                            borderColor: "#ff4949"
                          }}
                        ></label>
                      </div>
                    </div>
                    <div className="sib-input sib-form-block">
                      <div className="form__entry entry_block">
                        <div className="form__label-row ">
                          <label
                            className="entry__label"
                            style={{
                              fontWeight: 700,
                              textAlign: "left",
                              fontSize: 16,
                              fontFamily: "Helvetica, sans-serif",
                              color: "#3c4858"
                            }}
                            htmlFor="WEBSITE"
                            data-required="*"
                          >
                            Company Website
                          </label>
                          <div className="entry__field">
                            <input
                              className="input "
                              maxLength={200}
                              type="text"
                              id="WEBSITE"
                              name="WEBSITE"
                              autoComplete="off"
                              placeholder="https://"
                              data-required="true"
                              required=""
                            />
                          </div>
                        </div>
                        <label
                          className="entry__error entry__error--primary"
                          style={{
                            fontSize: 16,
                            textAlign: "left",
                            fontFamily: "Helvetica, sans-serif",
                            color: "#661d1d",
                            backgroundColor: "#ffeded",
                            borderRadius: 3,
                            borderColor: "#ff4949"
                          }}
                        ></label>
                      </div>
                    </div>
                  </div>
                  <div style={{ padding: "8px 0" }}>
                    <div
                      className="sib-multiselect sib-form--blockPosition sib-form-block"
                      data-required="true"
                    >
                      <div className="form__entry">
                        <div className="form__label-row ">
                          <label class="entry__label"
                            style={{ fontWeight: '700', textAlign: 'left', fontSize: '16px', fontFamily: 'Helvetica,sans-serif', color: '#3c4858' }} data-required="*">
                            Company Type
                          </label>
                          <div class="entry__field">
                            <div class="input input_display input--multiselect input--centerText" style={{ paddingRight: '0px' }}
                              onClick={() => setShowContactSelect(!showContactSelect)}>
                              {selectedCompanyType ? showSelectedCompanyType() : showSelectedCompanyType()}
                            </div>
                            <input id="lists" class="input" name="lists_39[]" type="hidden" value={selectedCompanyType} />
                          </div>
                          <div class="sib-menu"
                            style={{ textAlign: 'left', top: '72.4792px', width: '414.051px', left: '16px', display: (showContactSelect ? 'block' : 'none') }}>
                            <ul class="sib-menu__item-list">
                              <li class="sib-menu__item" onClick={() => changeCompanyType('6')}>
                                <div className="entry__choice">
                                  <label className="checkbox__label">
                                    <input
                                      type="checkbox"
                                      className="input_replaced"
                                      name="lists_26[]"
                                      data-value="Agency"
                                      value='6'
                                      data-required="true"
                                      checked={selectedCompanyType === '6' ? true : false}
                                    />
                                    <span
                                      className="checkbox checkbox_tick_positive"
                                      style={{ marginLeft: "" }}
                                    />
                                    <span
                                      style={{
                                        fontSize: 16,
                                        textAlign: "left",
                                        fontFamily: "Helvetica, sans-serif",
                                        color: "#3C4858",
                                        backgroundColor: "transparent"
                                      }}
                                    >
                                      Agency
                                    </span>{" "}
                                  </label>
                                </div>
                              </li>
                              <li class="sib-menu__item" onClick={() => changeCompanyType('7')}>
                                <div className="entry__choice">
                                  <label className="checkbox__label">
                                    <input
                                      type="checkbox"
                                      className="input_replaced"
                                      name="lists_26[]"
                                      data-value="Brand"
                                      value='7'
                                      data-required="true"
                                      checked={selectedCompanyType === '7' ? true : false}
                                    />
                                    <span
                                      className="checkbox checkbox_tick_positive"
                                      style={{ marginLeft: "" }}
                                    />
                                    <span
                                      style={{
                                        fontSize: 16,
                                        textAlign: "left",
                                        fontFamily: "Helvetica, sans-serif",
                                        color: "#3C4858",
                                        backgroundColor: "transparent"
                                      }}
                                    >
                                      Brand
                                    </span>{" "}
                                  </label>
                                </div>
                              </li>
                              <li className='sib-menu__item' onClick={() => changeCompanyType('8')}>
                                <div className="entry__choice">
                                  <label className="checkbox__label">
                                    <input
                                      type="checkbox"
                                      className="input_replaced"
                                      name="lists_26[]"
                                      data-value="Consultancy"
                                      value='8'
                                      data-required="true"
                                      checked={selectedCompanyType === '8' ? true : false}
                                    />
                                    <span
                                      className="checkbox checkbox_tick_positive"
                                      style={{ marginLeft: "" }}
                                    />
                                    <span
                                      style={{
                                        fontSize: 16,
                                        textAlign: "left",
                                        fontFamily: "Helvetica, sans-serif",
                                        color: "#3C4858",
                                        backgroundColor: "transparent"
                                      }}
                                    >
                                      Consultancy
                                    </span>{" "}
                                  </label>
                                </div>
                              </li>
                              <li className='sib-menu__item' onClick={() => changeCompanyType('9')}>
                                <div className="entry__choice">
                                  <label className="checkbox__label">
                                    <input
                                      type="checkbox"
                                      className="input_replaced"
                                      name="lists_26[]"
                                      data-value="Educational"
                                      value='9'
                                      checked={selectedCompanyType === '9' ? true : false}
                                      data-required="true"
                                    />
                                    <span
                                      className="checkbox checkbox_tick_positive"
                                      style={{ marginLeft: "" }}
                                    />
                                    <span
                                      style={{
                                        fontSize: 16,
                                        textAlign: "left",
                                        fontFamily: "Helvetica, sans-serif",
                                        color: "#3C4858",
                                        backgroundColor: "transparent"
                                      }}
                                    >
                                      Educational
                                    </span>{" "}
                                  </label>
                                </div>
                              </li>
                              <li className='sib-menu__item' onClick={() => changeCompanyType('10')}>
                                <div className="entry__choice">
                                  <label className="checkbox__label">
                                    <input
                                      type="checkbox"
                                      className="input_replaced"
                                      name="lists_26[]"
                                      data-value="Freelancer"
                                      value='10'
                                      data-required="true"
                                      checked={selectedCompanyType === '10' ? true : false}
                                    />
                                    <span
                                      className="checkbox checkbox_tick_positive"
                                      style={{ marginLeft: "" }}
                                    />
                                    <span
                                      style={{
                                        fontSize: 16,
                                        textAlign: "left",
                                        fontFamily: "Helvetica, sans-serif",
                                        color: "#3C4858",
                                        backgroundColor: "transparent"
                                      }}
                                    >
                                      Freelancer
                                    </span>{" "}
                                  </label>
                                </div>
                              </li>
                              <li className='sib-menu__item' onClick={() => changeCompanyType('22')}>
                                <div className="entry__choice">
                                  <label className="checkbox__label">
                                    <input
                                      type="checkbox"
                                      className="input_replaced"
                                      name="lists_26[]"
                                      data-value="Sigma Attendees"
                                      value='22'
                                      checked={selectedCompanyType === '22' ? true : false}
                                      data-required="true"
                                    />
                                    <span
                                      className="checkbox checkbox_tick_positive"
                                      style={{ marginLeft: "" }}
                                    />
                                    <span
                                      style={{
                                        fontSize: 16,
                                        textAlign: "left",
                                        fontFamily: "Helvetica, sans-serif",
                                        color: "#3C4858",
                                        backgroundColor: "transparent"
                                      }}
                                    >
                                      Sigma Attendees
                                    </span>
                                  </label>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </div>
                        <label
                          className="entry__error entry__error--primary"
                          style={{
                            fontSize: 16,
                            textAlign: "left",
                            fontFamily: "Helvetica, sans-serif",
                            color: "#661d1d",
                            backgroundColor: "#ffeded",
                            borderRadius: 3,
                            borderColor: "#ff4949"
                          }}
                        ></label>
                      </div>
                    </div>
                  </div>
                  <div style={{ padding: "8px 0" }}>
                    <div className="sib-optin sib-form-block" data-required="true">
                      <div className="form__entry entry_mcq">
                        <div className="form__label-row ">
                          <div className="entry__choice" style={{}}>
                            <label>
                              <input
                                type="checkbox"
                                className="input_replaced"
                                defaultValue={1}
                                id="OPT_IN"
                                name="OPT_IN"
                                required=""
                              />
                              <span
                                className="checkbox checkbox_tick_positive"
                                style={{ marginLeft: "" }}
                              />
                              <span
                                style={{ fontSize: '14px', textAlign: 'left', fontFamily: 'Helvetica sans-serif', color: '#3C4858', backgroundColor: 'transparent', marginLeft: '3px', marginTop: '-3px' }}
                              >
                                <p>By submitting this form you agree to receive content, events, and marketing emails
                                  from Adcropper. To learn more about how Adcropper uses your informations, check our <Link to={"/terms"}>terms</Link> and <Link to={"/privacy"}>privacy policy</Link>
                                </p>
                                <span
                                  data-required="*"
                                  style={{ display: "inline" }}
                                  className="entry__label entry__label_optin"
                                />
                              </span>{" "}
                            </label>
                          </div>
                        </div>
                        <label
                          className="entry__error entry__error--primary"
                          style={{
                            fontSize: 16,
                            textAlign: "left",
                            fontFamily: "Helvetica, sans-serif",
                            color: "#661d1d",
                            backgroundColor: "#ffeded",
                            borderRadius: 3,
                            borderColor: "#ff4949"
                          }}
                        ></label>
                      </div>
                    </div>
                  </div>
                  <div style={{ padding: "8px 0" }}>
                    <div className="sib-form-block" style={{ textAlign: "left" }}>
                      <button
                        className="sib-form-block__button sib-form-block__button-with-loader"
                        style={{
                          fontSize: 16,
                          textAlign: "left",
                          fontWeight: 700,
                          fontFamily: "Helvetica, sans-serif",
                          color: "#FFFFFF",
                          backgroundColor: "#3E4857",
                          borderRadius: 3,
                          borderWidth: 0
                        }}
                        form="sib-form"
                        type="submit"
                      >
                        SUBMIT
                      </button>
                    </div>
                  </div>
                  <input
                    type="text"
                    name="email_address_check"
                    defaultValue=""
                    className="input--hidden"
                  />
                  <input type="hidden" name="locale" defaultValue="en" />
                  <input type="hidden" name="html_type" defaultValue="simple" />
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ParticlesAuth>
  )
}

export default Sigma
